import React from "react";

import { styled } from "@mui/material/styles";
import { Button, Typography } from "@mui/material";
import { c } from '@/theme/colorUtils';

const ButtonStyle = styled(Button)(
  ({ theme, background, border, disabled, hasIcon }) => ({
    "&.MuiButtonBase-root": {
      width: "100%",
      padding: 16,
      boxSizing: "border-box",
      borderRadius: 8,
      background: background,
      border: border
        ? `1px solid ${border}`
        : disabled
          ? `1px solid #F0F1F5`
          : `1px solid ${background}`,
      gap: hasIcon ? 8 : 0,
      "&:hover": {
        background: background,
      },
      "&.Mui-disabled": {
        background: "#F0F1F5",
        "& p": {
          color: "#C9C9CA",
        },
      },
    },
  }),
);

const TextStyle = styled(Typography)(({ theme, color }) => ({
  "&.MuiTypography-root": {
    fontSize: "1rem",
    fontWeight: 400,
    lineHeight: "19.6px",
    color: color,
    textTransform: "none",
    textAlign: "center",
  },
}));

const IconContainer = styled("div")(({ theme, position }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: c.text02,
  "& svg": {
    width: 20,
    height: 20,
  },
}));


export default function CommonButton(props) {
  const { 
    id, 
    text, 
    background, 
    border, 
    color, 
    onClick, 
    disabled,
    icon,
    iconPosition = "left"
  } = props;

  return (
    <ButtonStyle
      id={id}
      onClick={onClick}
      background={background}
      border={border}
      disabled={disabled}
      disableRipple
      hasIcon={!!icon}
    >
      {icon && iconPosition === "left" && (
        <IconContainer position="left">
          {icon}
        </IconContainer>
      )}
      <TextStyle color={color}>{text}</TextStyle>
      {icon && iconPosition === "right" && (
        <IconContainer position="right">
          {icon}
        </IconContainer>
      )}
    </ButtonStyle>
  );
}
